import React from "react";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';

const TextFormField = ({
  input,
  type,
  label,
  loading,
  startAdornment,
  endAdornment,
  readOnly,
  disabled,
  helperText = "",
  meta: { touched, error },
  min, max,
  ...custom
}) => {
  return (
    <TextField
      type={type}
      label={label}
      disabled={disabled}
      variant="standard"
      error={Boolean(touched && error)}
      helperText={(touched && error) || helperText}
      InputProps={{
        startAdornment,
        readOnly: readOnly,
        inputProps: { min, max },
        endAdornment: endAdornment ? (
          endAdornment
        ) : loading ? (
          <InputAdornment position="start">
            <CircularProgress
              variant="indeterminate"
              size={16}
              thickness={4}
            />
          </InputAdornment>
        ) : undefined,
      }}
      {...input}
      {...custom}
    />
  );
};

export default TextFormField;
